var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabilifeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 32,
    viewBox: "0 0 142 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\xE3\x83\xAC\xE3\x82\xA4\xE3\x83\xA4\xE3\x83\xBC_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.303 10.5163H33.5376V7.59412H48.4167V10.5184H42.6513V26.4055H39.3051V10.5163H39.303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M57.8251 24.7824H57.7462C57.1081 25.8985 55.595 26.7215 53.7869 26.7215C51.7397 26.7215 49.0066 25.7384 49.0066 22.7622C49.0066 18.9629 53.7869 18.4329 57.7732 18.4329V18.1149C57.7732 16.5458 56.443 15.7768 54.8531 15.7768C53.498 15.7768 52.1969 16.4148 51.3718 17.2379L49.7257 15.2987C51.1598 13.9686 53.18 13.2786 55.1191 13.2786C59.6895 13.2786 60.8035 16.0948 60.8035 18.6449V26.4014H57.8272V24.7803L57.8251 24.7824ZM57.7732 20.5841H57.0561C55.036 20.5841 52.1948 20.8231 52.1948 22.7082C52.1948 23.9302 53.3379 24.3023 54.427 24.3023C56.6051 24.3023 57.7732 23.0553 57.7732 21.0351V20.5841Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M68.0679 6.31763V15.2734H68.1468C68.8119 14.4503 70.086 13.2823 72.4241 13.2823C76.0655 13.2823 78.6136 16.2024 78.6136 19.9788C78.6136 23.7552 76.2234 26.7793 72.3431 26.7793C70.5619 26.7793 68.8369 25.9541 67.9598 24.493H67.9078V26.4051H64.8796V6.31763H68.072H68.0679ZM71.7092 15.8823C69.371 15.8823 67.964 18.0334 67.964 20.0266C67.964 22.0198 69.371 24.1189 71.7092 24.1189C74.1804 24.1189 75.3754 21.9678 75.3754 19.9746C75.3754 17.9815 74.1804 15.8844 71.7092 15.8844V15.8823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M95.9305 7.59412H99.2767V23.4293H107.272V26.4055H95.9305V7.59412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M85.2511 13.6526H82.0629V26.4034H85.2511V13.6526Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M113.574 13.6526H110.386V26.4034H113.574V13.6526Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M119.757 16.2028H117.339V13.6526H119.757V11.7675C119.757 8.7102 120.952 6 124.909 6C125.599 6 126.052 6.05196 126.53 6.18705L126.318 8.89726C125.973 8.79126 125.549 8.7102 125.096 8.7102C123.263 8.7102 122.945 10.3043 122.945 11.5784V13.6505H125.894V16.2007H122.945V26.4034H119.757V16.2007V16.2028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M140.973 21.037H131.275C131.408 22.8452 133.057 24.1712 134.917 24.1712C136.511 24.1712 137.573 23.5332 138.29 22.5251L140.414 24.2253C139.167 25.9254 137.359 26.7754 134.942 26.7754C131.009 26.7754 128.089 24.2502 128.089 20.108C128.089 15.9658 130.984 13.2805 134.838 13.2805C138.398 13.2805 141 15.5917 141 20.187C141 20.4779 141 20.744 140.973 21.037ZM137.81 18.7508C137.81 17.1047 136.881 15.6686 134.807 15.6686C132.921 15.6686 131.404 16.9717 131.273 18.7508H137.81Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M83.6473 11.2192C84.7034 11.2192 85.5594 10.3632 85.5594 9.30713C85.5594 8.2511 84.7034 7.39502 83.6473 7.39502C82.5913 7.39502 81.7352 8.2511 81.7352 9.30713C81.7352 10.3632 82.5913 11.2192 83.6473 11.2192Z",
    fill: "url(#paint0_linear_2201_333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M111.987 11.2192C113.043 11.2192 113.899 10.3632 113.899 9.30713C113.899 8.2511 113.043 7.39502 111.987 7.39502C110.931 7.39502 110.074 8.2511 110.074 9.30713C110.074 10.3632 110.931 11.2192 111.987 11.2192Z",
    fill: "url(#paint1_linear_2201_333)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20.3564 15.5877L26.789 11.8737L28.7614 15.2947C29.2893 16.2112 29.5865 17.0571 29.6489 17.8303C29.7154 18.6097 29.5366 19.3163 29.1147 19.9502C28.6887 20.5945 28.0298 21.1744 27.134 21.6898L24.6919 23.1011L20.3544 15.5877H20.3564Z",
    fill: "url(#paint2_linear_2201_333)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M5.31887 24.124L1 16.6439L5.83015 11.0156L7.05847 13.146L8.9394 12.061L9.40704 12.8695L7.52818 13.9545L13.5742 24.4295L13.1024 24.7017C12.0403 25.3128 10.9928 25.6973 9.94949 25.8532C8.88329 26.0236 7.95009 25.9529 7.15408 25.6432C6.33727 25.344 5.72415 24.8368 5.31263 24.1219H5.31471L5.31887 24.124Z",
    fill: "url(#paint3_linear_2201_333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M14.888 8.62755L8.86365 12.1057L17.5824 27.2071L23.6068 23.7289L14.888 8.62755Z",
    fill: "url(#paint4_linear_2201_333)"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2201_333",
    x1: 81.7352,
    y1: 9.30713,
    x2: 85.5615,
    y2: 9.30713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3FC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3DBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#39A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#358CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3380FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2201_333",
    x1: 110.074,
    y1: 9.30713,
    x2: 113.899,
    y2: 9.30713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#3B6F30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366B2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2201_333",
    x1: 20.3564,
    y1: 17.4853,
    x2: 29.6634,
    y2: 17.4853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#663D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#6C413E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#7E4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#9B6626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16B24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2201_333",
    x1: 1,
    y1: 18.4791,
    x2: 13.5763,
    y2: 18.4791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3FC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3DBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#39A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#358CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3380FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2201_333",
    x1: 8.86212,
    y1: 17.9175,
    x2: 23.6041,
    y2: 17.9175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#3B6F30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366B2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabilifeLogo);
export default __webpack_public_path__ + "static/media/tabilife-logo.0a6b03072a4e52e29bf9073d98bc1721.svg";
export { ForwardRef as ReactComponent };